import { useEffect, useState } from "react";
import { Activity as ActIcon } from "lucide-react";
import { PageHeader, EmptyState, PageLoading, fmtDateTime } from "@/components/shared";
import api from "@/lib/api";

export default function ActivityLog() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/employer/activity").then((r) => setItems(r.data.activity)); }, []);
  if (items === null) return <><PageHeader title="Activity" /><PageLoading /></>;
  return (
    <div data-testid="activity-page">
      <PageHeader title="Activity" subtitle="A record of actions across your organization." />
      {items.length === 0 ? <EmptyState icon={ActIcon} title="No activity yet" subtitle="Actions will appear here as you manage your workforce." /> : (
        <div className="card-soft divide-y divide-slate-50">
          {items.map((a) => (
            <div key={a.id} className="flex items-start gap-3 px-4 py-3.5">
              <div className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-500"><ActIcon className="h-4 w-4" /></div>
              <div className="flex-1">
                <div className="text-sm"><span className="font-semibold text-navy capitalize">{a.action.replace(/[._]/g, " ")}</span>{a.employee_name && <span className="text-slate-500"> · {a.employee_name}</span>}</div>
                <div className="text-xs text-slate-400">{a.actor_name} ({a.actor_email})</div>
              </div>
              <div className="text-xs text-slate-400">{fmtDateTime(a.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
